import * as React from 'react';
import { DefaultButton, PrimaryButton, Stack } from 'office-ui-fabric-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ActionCluster = props => {
  var _props$actionDisabled;
  return /*#__PURE__*/_jsxs(Stack, {
    horizontal: true,
    style: {
      marginTop: 10
    },
    children: [/*#__PURE__*/_jsx(DefaultButton, {
      onClick: props.onCancel,
      style: {
        marginRight: 10
      },
      children: "Cancel"
    }), /*#__PURE__*/_jsx(PrimaryButton, {
      disabled: (_props$actionDisabled = props.actionDisabled) !== null && _props$actionDisabled !== void 0 ? _props$actionDisabled : false,
      onClick: props.onAction,
      children: props.actionText
    })]
  });
};